<template>
  <a-modal width="40%"
           :visible="visible"
           :confirmLoading="confirmLoading"
           @cancel="handleCancel"
           wrapClassName="ant-modal-cust-warp"
           style="top:5%;height:90%;">
    <template #title>
      <mtcLangPopover text="modalTitle.importFormFromDatabase" />
    </template>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper" style="padding-bottom: 0;margin-bottom: 0">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="24">
            <mtc-form-item label="label.tableName" style="padding-bottom: 0;margin-bottom: 0">
              <a-input :placeholder="$t('tip.pleaseEnterTableName')" v-model="filterId" @pressEnter="searchFilter"></a-input>
            </mtc-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-alert style="margin: 10px 0">
      <template slot="message">
        <a-icon class="anticon ant-alert-icon" theme="filled" type="info-circle" />
        <span style="margin-left: 20px">
          <!-- 已选择 -->
          <mtcLangPopover text="tip.selected" />：
          <!-- 条数 -->
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
          <!-- 单位 -->
          <mtcLangPopover text="tip.term" />
          <mtcLangPopover text="button.clear">
            <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
          </mtcLangPopover>
        </span>
      </template>
    </a-alert>
    <!-- <div style="margin:5px 0;">
      注：导入表会排除配置前缀表
      <a href="http://doc.jeecg.com/1898410" target="_blank"> 参考文档</a>
    </div>-->
    <a-table ref="table"
             size="small"
             bordered
             rowKey="id"
             :pagination="pagination"
             :columns="tableColumns"
             :dataSource="dataSource"
             :locale="{'emptyText':emptyText}"
             @change="handleTableChange"
             :loading="confirmLoading"
             :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}">
      <!-- 表头自定义渲染 -->
      <template v-for="(item, index) in tableColumns" :slot="item.slotName">
        <mtcHeader :key="index" :text="item.slotName" />
      </template>
    </a-table>
    <template slot="footer">
      <mtc-button @click="handleCancel" text="button.close" style="margin-right: 8px" />
      <mtc-button @click="handleTrans" type="primary" icon="swap" :loading="btnLoading" text="button.generateForm" />
    </template>
  </a-modal>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { changeLangColumn } from '@/utils/langUtils'

export default {
  name: 'TransDb2Online',
  title: '从数据库导入表单弹框',
  data() {
    return {
      modalWidth: 500,
      visible: false,
      emptyText: '暂无数据',
      confirmLoading: false,
      btnLoading: false,
      queryUrl: '/online/cgform/head/queryTables/',
      transUrl: '/online/cgform/head/transTables/',
      metaSource: [],
      dataSource: [],
      filterId: '',
      pagination: {
        simple: false,
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50'],
        showTotal: (total, range) => {
          return `${range[ 0 ]}-${range[ 1 ]}${this.$t('tip.total')}${total}${this.$t('tip.article')}`
        },
        showSizeChanger: true,
        total: 0
      },
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '表名',
          language_key: 'tableHeader.tableName',
          align: 'left',
          dataIndex: 'id'
        }
      ],
      selectedRowKeys: []
    }
  },
  computed: {
    tableColumns() {
      return changeLangColumn(this.columns)
    }
  },
  methods: {
    show() {
      this.visible = true
      this.btnLoading = false
      this.filterId = ''
      this.emptyText = '暂无数据'
      this.selectedRowKeys = []
      this.queryTables()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination
      //this.queryTables();
    },
    onClearSelected() {
      this.selectedRowKeys = []
    },
    queryTables() {
      this.confirmLoading = true
      var param = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        tableName: this.filterId
      }
      getAction(this.queryUrl, param).then(res => {
        this.confirmLoading = false
        if (res.success) {
          this.dataSource = res.result
          this.metaSource = [...res.result]
        } else {
          if (res.message == 'noadminauth') {
            this.$message.warning('非admin用户无权限操作!')
            this.emptyText = '非admin用户无权限操作!'
          } else {
            this.$message.warning(res.message)
          }
        }
      })
    },
    searchFilter() {
      if (!this.filterId) {
        this.dataSource = [...this.metaSource]
      } else {
        this.dataSource = this.metaSource.filter((item) => item.id.indexOf(this.filterId) >= 0)
      }
    },
    searchReset() {
      this.filterId = ''
      this.searchFilter()
    },
    handleCancel() {
      this.visible = false
    },
    handleSuccess() {
      this.visible = false
      this.$emit('ok')
    },
    handleTrans() {
      if (!this.selectedRowKeys || this.selectedRowKeys.length == 0) {
        this.$message.warning('请选择一张表')
        return
      } else {
        this.btnLoading = true
        let tbnames = this.selectedRowKeys.join(',')
        postAction(this.transUrl + tbnames).then(res => {
          this.btnLoading = false
          if (res.success) {
            this.$message.success(res.message)
            this.handleSuccess()
          } else {
            this.$message.warning(res.message)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.ant-modal-cust-warp {
  height: 100%
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden
}
</style>